import { useTranslation } from 'react-i18next'

import { MenuContent, MenuItemGroup } from '@/components/ui/menu'

import HelpCenterDrawer from '../drawer'
import HelpCenterList from './HelpCenterList'

const HelpCenterMenuList = () => {
    const { t } = useTranslation()

    return (
        <>
            <HelpCenterDrawer />
            <MenuContent>
                <MenuItemGroup title={t('global.helpCenter.menu.groupTitle')}></MenuItemGroup>
                <HelpCenterList />
            </MenuContent>
        </>
    )
}

export default HelpCenterMenuList
